export default __webpack_public_path__ + "static/media/appertflow__imagotipo--negativo_1.0d6cbdb6.png";